/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/location';
import './common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboarding": {
        "nested": {
          "business": {
            "nested": {
              "AuBusiness": {
                "fields": {
                  "tradingName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "legalName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "category": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "subCategory": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "australianBusinessNumber": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "australianCompanyNumber": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "businessStructure": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "globalAddress": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 8,
                    "rule": "optional"
                  },
                  "merchantAnalytic": {
                    "type": "squareup.onboarding.business.common.MerchantAnalytic",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "type": {
                    "type": "squareup.onboarding.business.AuBusiness.Type",
                    "id": 10,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "UNKNOWN": 0,
                      "BUSINESS": 1,
                      "INDIVIDUAL": 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.AuBusiness && !$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.AuBusiness?.nested?.Type) {
  $root.addJSON(jsonData);
}

/**
 * Represents a business entity in Australia.
 *
 * SOURCE AuBusiness @ squareup/onboarding/business/au.proto at 13:1
 */
export const AuBusiness = $root.lookupType('squareup.onboarding.business.AuBusiness');
fixType(AuBusiness);
Builder.createAndAttachToType(AuBusiness);
/**
 * SOURCE Type @ squareup/onboarding/business/au.proto at 65:3
 */
AuBusiness.Type = $root.lookupEnum('squareup.onboarding.business.AuBusiness.Type').values;